module.exports = {
      id: "45b0d0d115ccdfd8ba0d39bd241a4608state-to-demolition.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#45b0d0d115ccdfd8ba0d39bd241a4608state-to-demolition.svg",
      toString: function () {
        return this.url;
      }
    }